import { AccountDeletedPage, AuthCallbackPage } from "@certn/auth";
import * as Sentry from "@sentry/react";
import { Route, Routes, useNavigate } from "react-router-dom";

import { ProtectedRoutes } from "./ProtectedRoutes";
import { SignupRoute } from "./SignupRoute";
import { AlreadyRegistered } from "../pages/already-registered/AlreadyRegistered";
import { InteracSessionCompleteOrCancelled } from "../pages/application/InteracSessionRedirect";
import { ApplyLinkPage } from "../pages/apply-link/ApplyLinkPage";
import { CRCVerifCodeRequestPage } from "../pages/crc-verification-code-request/CRCVerifCodeRequestPage";
import { CRCVerifEnterCodePage } from "../pages/crc-verification-code-request/CRCVerifEnterCodePage";
import { CredentialRequestDeclined } from "../pages/decline-request/CredentialRequestDeclined";
import { DeclineCredentialRequest } from "../pages/decline-request/DeclineCredentialRequest";
import { DeclineRequest } from "../pages/decline-request/DeclineRequest";
import { RequestDeclined } from "../pages/decline-request/RequestDeclined";
import { KonfirCallback } from "../pages/konfir/KonfirCallback";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function BaseRoutes() {
  const navigate = useNavigate();

  return (
    <SentryRoutes>
      <Route
        path="/callback"
        element={<AuthCallbackPage onContinue={() => navigate("/")} />}
      />
      <Route path="/account-deleted" element={<AccountDeletedPage />} />
      <Route path="/:caseId/decline-invite" element={<DeclineRequest />} />
      <Route
        path="/:credentialRequestId/decline-request"
        element={<DeclineCredentialRequest />}
      />
      <Route path="/request-declined" element={<RequestDeclined />} />
      <Route
        path="/credential-request-declined"
        element={<CredentialRequestDeclined />}
      />
      <Route path="/signup" element={<SignupRoute />} />
      <Route path="/apply-link/:applyLinkId" element={<ApplyLinkPage />} />
      <Route
        path="/apply-link/already-registered"
        element={<AlreadyRegistered />}
      />
      <Route
        path="/interac-session-complete/:caseId"
        element={<InteracSessionCompleteOrCancelled />}
      />
      <Route path="/konfir/callback" element={<KonfirCallback />} />
      <Route path="/my-crc/certificate" element={<CRCVerifCodeRequestPage />} />
      <Route
        path="/my-crc/certificate/access-code"
        element={<CRCVerifEnterCodePage />}
      />
      <Route path="*" element={<ProtectedRoutes />} />
    </SentryRoutes>
  );
}
